import ListItem from "@mui/joy/ListItem";
import ListItemContent from "@mui/joy/ListItemContent";
import Typography from "@mui/joy/Typography";
import { Stack, Textarea } from "@mui/joy";

export default function ConcernAndGoal({
  concern,
  goal,
}: {
  concern?: string;
  goal?: string;
}) {
  return (
    <ListItem>
      <ListItemContent>
        <Stack spacing={2}>
          {Object.entries({ concern: concern, goal: goal }).map(
            ([key, value]) => (
              <Stack spacing={1} key={key}>
                <Stack direction={"row"} justifyContent="space-between">
                  <Typography level="body-xs">
                    {key === "concern" ? "고민" : "목표"}
                  </Typography>
                </Stack>

                <Textarea
                  value={value || ""}
                  sx={{
                    width: "100%",
                    borderWidth: "2px",
                    borderColor: "background.level3",
                    backgroundColor: "background.level2",
                    "--joy-focus-thickness": "0px",
                    boxShadow: "0px 0px 0px transparent",
                  }}
                  readOnly
                ></Textarea>
              </Stack>
            )
          )}
        </Stack>
      </ListItemContent>
    </ListItem>
  );
}
